import type { SupportedLangCode } from '@/application/i18n/language'

/** The date every legal page was last revised, ISO `YYYY-MM-DD`. */
export const LEGAL_PAGES_LAST_UPDATED = '2026-08-31'

const LOCALE_BY_LANG: Record<SupportedLangCode, string> = {
  fr: 'fr-FR',
  en: 'en-US',
  es: 'es-ES',
}

/** Formats `LEGAL_PAGES_LAST_UPDATED` as a human-readable date in the given language. */
export function formatLastUpdated(lang: SupportedLangCode): string {
  const date = new Date(`${LEGAL_PAGES_LAST_UPDATED}T00:00:00Z`)
  return new Intl.DateTimeFormat(LOCALE_BY_LANG[lang], {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(date)
}
